import { Component, Directive, Input, OnInit, OnDestroy } from '@angular/core';
import {
	AbstractControl,
	FormArray,
	FormBuilder,
	FormGroup,
	Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormArrayBase } from '@base/FormBase';
// SERVICES
import { AnswerService } from '@services/answer/answer.service';
import { QuestionBankService } from '@services/question-bank/question-bank.service';
// MODELS
import { Response } from '@models/response-api/ResponseApi';
import { Answer } from '@models/answer/Answer';
import { Question } from '@models/question/Question';
import { AlertService } from '@services/notification/alert.service';
import { QuestionBank } from '@models/question-bank/QuestionBank';
import { HttpErrorResponse } from '@angular/common/http';
// TODO : TAG GTM
declare var dataLayer: any;
@Directive()
export abstract class AnswerBase extends FormArrayBase implements OnInit, OnDestroy {
	subscription = new Subscription();
	answers: Answer[] = [];
	form!: FormGroup;
	@Input() question!: Question;
	_disabled = false;
	@Input() set disabled(value: boolean) {
		this._disabled = value;
		value ? this.form.disable() : this.form.enable();
	}
	cct: string | null = '';
	typeSchool: string | null = '';
	constructor(
		private fb: FormBuilder,
		private alertService: AlertService,
		private answerService: AnswerService,
		private questionBankService: QuestionBankService
	) {
		super();
		this.createForm();
	}

	ngOnInit() {
		this.cct = localStorage.getItem('cct');
		this.typeSchool = localStorage.getItem('typeSchool');
		this.loadData();
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	createForm() {
		this.form = this.fb.group({
			answers: this.fb.array([]),
		});
	}

	get formAnswers(): FormArray {
		return this.form.get('answers') as FormArray;
	}

	trackByFn(index: any, item: AbstractControl) {
		return item.value.id;
	}

	abstract finishLoadData(): void;

	loadData() {
		this.subscription.add(
			this.questionBankService.getById(this.question.questionBankId).subscribe({
				next: (x: Response) => {
					const { data } = x;
					const questions = (data as QuestionBank)?.questions || [];
					const question: Question = questions.filter((x) => x.id == this.question.id)[0];
					this.answers = question.answers || [];
					this.answers.forEach((x) => {
						const formAnswer = this.createFormAnswer(x);
						this.formAnswers.push(formAnswer);
					});
					this.finishLoadData();
				},
				error: (err: HttpErrorResponse) => console.log(err.message),
			})
		);
	}

	addNewAnswer() {
		const [, option] = this.createDefaultAnswer();
		this.save(option);
	}

	createDefaultAnswer(): [any, Answer] {
		const answer: Answer = this.createAnswer();
		const formAnswer = this.createFormAnswer(answer);
		return [formAnswer, answer];
	}

	createAnswer(): Answer {
		return {
			description: '',
			isCorrect: false,
			questionId: this.question.id,
			active: true,
			relationDescription: '',
		};
	}

	createFormAnswer(item: Answer) {
		return this.fb.group({
			id: [item.id, [Validators.required]],
			questionId: [item.questionId, [Validators.required]],
			description: [item.description, Validators.required],
			isCorrect: [item.isCorrect, [Validators.required]],
			active: [true],
			relationDescription: [item.relationDescription, Validators.required],
		});
	}

	save(data: Answer) {
		this.subscription.add(
			this.answerService.save(data).subscribe({
				next: (data: Response) => {
					const formAnswer = this.createFormAnswer(data.data);
					this.formAnswers.push(formAnswer);
				},
				error: (err: any) => console.log(err.message),
			})
		);
	}

	async confirmDeletionAnswer(index: number, answer: Answer, $event: Event) {
		$event.stopPropagation();
		if (await this.alertService.showConfirmationDeletion()) {
			this.deleteAnswer(index, answer);
		}
	}

	deleteAnswer(index: number, answer: Answer) {
		this.subscription.add(
			this.answerService.remove(answer).subscribe({
				next: (x: Response) => {
					if (x.success) {
						this.formAnswers.removeAt(index);
						this.alertService.showSuccess(x.message);
					} else {
						dataLayer.push({
							event: 'error_message', //Static data
							content_group: 'Banco de preguntas', //Dynamic data
							error_messgae_text: x.message, //Dynamic data
							error_messgae_location: 'Eliminar pregunta', //Dynamic data
							cct: this.cct, //Dynamic data
							school_type: this.typeSchool,
						});
						this.alertService.showError(x.message);
					}
				},
				error: (err: any) => console.log(err.message),
			})
		);
	}
}
